import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=57e8c6dd&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
import style0 from "./Projects.vue?vue&type=style&index=0&id=57e8c6dd&prod&lang=css"
import style1 from "./Projects.vue?vue&type=style&index=1&id=57e8c6dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e8c6dd",
  null
  
)

export default component.exports